import { useMutation, useQueryClient } from "@tanstack/react-query";
import { solicitudesApi } from "@/features/solicitudes/services/solicitudes.api";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastInfo } from "@/lib/toast";

/**
 * Mutation para cancelar una solicitud · acción terminal (decisión 30).
 * Al éxito hidrata el cache + invalida listado · la navegación de salida
 * la decide el caller via `options.onSuccess`.
 */
export function useCancelarSolicitud(
  solicitudId: string,
  options?: { onSuccess?: () => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (motivos: string[]) =>
      solicitudesApi.cancelar(solicitudId, motivos),
    onSuccess: (sol) => {
      qc.setQueryData(qk.solicitud(solicitudId), sol);
      qc.invalidateQueries({ queryKey: qk.misSolicitudes });
      toastInfo({ title: "Solicitud cancelada", message: `Solicitud #${sol.numeroSolicitud}` });
      options?.onSuccess?.();
    },
    onError: toastErrorApi,
  });
}
